import firebase from 'firebase'
import firestore from 'firebase/firestore'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyAHt7qYxD0Iv3zAhXMptsS2rhNjmnt-QrE",
  authDomain: "aaron-farr-website.firebaseapp.com",
  databaseURL: "https://aaron-farr-website.firebaseio.com",
  projectId: "aaron-farr-website",
  storageBucket: "aaron-farr-website.appspot.com",
  messagingSenderId: "112347635847"
};
const firebaseApp = firebase.initializeApp(config)
export default firebaseApp

//firebaseApp.firestore().settings({ timestampsInSnapshots: true })
//export default firebaseApp.firestore()